import { callable, computable, mix, observable, watch } from "@chorda/core";
export const withMultiselect = (blueprint) => {
    return mix(blueprint, {
        defaults: {
            selected: () => observable([]),
        },
        injections: {
            selectItem: ({ value }) => callable((itm) => {
                if (value.includes(itm.$value.id)) {
                    value.$value = value.filter(v => v != itm.$value.id);
                }
                else {
                    value.$value = [...value, itm.$value.id];
                }
                return itm;
            }),
            triggerText: ({ selected }) => computable(() => selected.map(s => s.name).join(',')),
        },
        joints: {
            initDropdown: ({ value, items, selected, active, current }) => {
                watch(() => {
                    selected.$value = value.map(v => {
                        let found = null;
                        items.forEach(itm => {
                            if (itm.id == v) {
                                found = itm;
                            }
                        });
                        return found;
                    });
                }, [value, items]);
                watch(() => {
                    if (active.$value) {
                        current.$value = selected[selected.length - 1];
                    }
                }, [active]);
            }
        }
    });
};
